module.exports = __webpack_public_path__ + "img/cargo.f00113fe.svg";